// authProvider.js
import { PublicClientApplication } from "@azure/msal-browser";
import env from "../env";
// Msal Configurations
const { REACT_APP_BASE_URI, REACT_APP_MSAL_AUTHORITY, REACT_APP_CLIENT_ID, REACT_APP_SCOPE } = env;

export const config = {
  auth: {
    authority:
    REACT_APP_MSAL_AUTHORITY,
    clientId: REACT_APP_CLIENT_ID,
    redirectUri: REACT_APP_BASE_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [REACT_APP_SCOPE], // optional Array<string>
};

// Forces the AAD account picker instead of silently reusing whatever account/session the
// browser already has cached. Without this, a stale SSO session for the wrong account can be silently reused and rejected,
// which looks like "access denied" with no way for the user to pick the right account.
export const interactiveLoginRequest = {
  ...loginRequest,
  prompt: "select_account",
};

export const msalInstance = new PublicClientApplication(config);
